import DepressionSelfTest from './DepressionSelfTest';

export default DepressionSelfTest;
